import { XrButton } from './styles';
import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import imgUrl from '@png/xero/connect_with_xero.png';
import disabledImgUrl from '@png/xero/disabled_connect_with_xero.png';

type Props = {
  disabled?: boolean;
} & ButtonProps;

export default ({ disabled, ...props }: Props) => (
  <XrButton {...props} disabled={disabled}>
    {disabled ? (
      <img height="50px" src={disabledImgUrl} alt="Connect with Xero" />
    ) : (
      <img height="50px" src={imgUrl} alt="Connect with Xero" />
    )}
  </XrButton>
);
